import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const AccountClientListPage = lazy(() => import('../views/list/AccountClientListPage'));

export function AccountClientListPageLazy() {
	return (
		<PageSuspense>
			<AccountClientListPage />
		</PageSuspense>
	);
}
